'use client'

import React, { useEffect } from 'react'
import styles from './styles.module.css'
import Page from './Page'
import CarouselIndicators from '../../CarouselIndicators'

import { useUiStore } from '../../../store/uiStore'

function HeaderGallery1(props) {
  const { pages, _key, isPageHero = false } = props
  // The carousel index map + its global 12s auto-advance interval moved off
  // Overmind to the Zustand ui store (Phase C2 part 1). registerCarousel mirrors
  // actions.addCarouselToState; setCarouselIndex mirrors actions.carouselIndicatorClicked.
  const currentCarouselIndexes = useUiStore((s) => s.currentCarouselIndexes)
  const registerCarousel = useUiStore((s) => s.registerCarousel)
  const setCarouselIndex = useUiStore((s) => s.setCarouselIndex)

  useEffect(() => {
    registerCarousel({ key: _key, length: pages.length })
  }, [_key, registerCarousel, pages.length])

  const activeIndex = currentCarouselIndexes[_key] ? currentCarouselIndexes[_key].currentIndex : 0

  return (
    <div className={styles.pages}>
      <div className={styles.pagesContent} style={{ left: `-${activeIndex}00%` }}>
        {pages.map((page, index) => {
          return <Page totalPages={pages.length} pageIndex={index} page={page} key={page._key} carouselKey={_key} isPageHero={isPageHero}/>
        })}
      </div>
      {pages.length > 1 && (<div className={styles.carouselIndicatorsWrapper}>
          <CarouselIndicators total={pages.length} activeIndex={activeIndex} onClick={(currentIndex) => setCarouselIndex({ currentIndex, key: _key })}/>
        </div>
      )}
    </div>
  )
}

export default HeaderGallery1
